import React from "react";

import { useScope } from "~/tools/impulse";
import type { ImpulseFormList } from "~/tools/impulse-form";
import { splice } from "~/tools/splice";

import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import { WidgetQuery } from "../widget-form/query/form-state";

import { SetupDashboardWidgetQuery } from "./_query/field";

export interface SetupDashboardWidgetQueriesProps {
	timeRange: TimeRange;
	queries: ImpulseFormList<WidgetQuery>;
}

export const SetupDashboardWidgetQueries: React.FC<SetupDashboardWidgetQueriesProps> = ({ timeRange, queries }) => {
	const scope = useScope();

	return (
		<div>
			<ol className="space-y-4">
				{queries.getElements(scope).map((query, index, arr) => (
					<li key={index}>
						<SetupDashboardWidgetQuery
							name={`Query #${index + 1}`}
							onDelete={
								arr.length > 1
									? () => {
											queries.setElements(splice(index, 1, []));
										}
									: undefined
							}
							query={query}
							timeRange={timeRange}
						/>
					</li>
				))}
			</ol>

			<footer className="mt-6 flex flex-row gap-3">
				<button
					className="button button-secondary uppercase"
					onClick={() => {
						queries.setElements((current) => [...current, WidgetQuery.init()]);
					}}
					type="button"
				>
					Add query
				</button>

				{queries.isDirty(scope) && (
					<button className="button button-tertiary uppercase" onClick={() => queries.reset()} type="button">
						Reset queries
					</button>
				)}
			</footer>
		</div>
	);
};
